import {TopNavBarButtonComponent, TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import React, {Fragment} from 'react';
import {Modal} from 'module/Modal/component/Modal';
import {ModalKey} from 'module/Modal/type/ModalKey';
import {useOpenModalCallback} from 'module/Modal/hook/useOpenModalCallback';

const MODAL_KEY = ModalKey.AppVersionInfo;

export const AppVersionInfoButton = React.memo((props: TopNavBarButtonProps) => {
	const onClick = useOpenModalCallback(MODAL_KEY);
	const versionEl = document.getElementById('AppVersionInfo');
	const innerHtml = versionEl?.innerHTML || null
	return (
		<Fragment>
			<TopNavBarButtonComponent onClick={onClick}{...props}>
				SISworld
			</TopNavBarButtonComponent>
			<Modal
				modalKey={MODAL_KEY}
				defaultSize={{height: 300, width: 300}}
				title={'Versionsinformationen'}
				padContent
			>
				{innerHtml && <div dangerouslySetInnerHTML={{__html: innerHtml}}/>}
			</Modal>
		</Fragment>
	);
});